import React, { useCallback, useState } from "react";
import { PopupWindow } from "@shopflo/ui/popup";
import AuthLogin from "./AuthLogin";
import TermsConditions from "components/common/TermsConditions";
import ShopfloBadge from "components/common/ShopfloBadge";
import { ConsentForm } from "lib/hooks/useConsentForm";

interface LoginProps {
  setCurrentWindow: (value: PopupWindow) => void;
  setAuthToken: (value: string) => void;
  onOtpDialogChange?: (isOtpDialog: boolean) => void;
  validSSORequestId?: string | null;
  consentForm?: ConsentForm;
}

const Login: React.FC<LoginProps> = ({
  setCurrentWindow,
  setAuthToken,
  onOtpDialogChange,
  validSSORequestId,
  consentForm,
}) => {
  // Local mirror of OTP-step flag so we can hide terms on the OTP screen while still notifying the parent.
  const [isOtpStep, setIsOtpStep] = useState<boolean>(false);

  const handleOtpDialogChange = useCallback(
    (next: boolean) => {
      setIsOtpStep(next);
      onOtpDialogChange?.(next);
    },
    [onOtpDialogChange],
  );

  return (
    <div className="flex w-full flex-1 flex-col items-center">
      <div className="flex w-full flex-col items-center">
        <AuthLogin
          setCurrentWindow={setCurrentWindow}
          setAuthToken={setAuthToken}
          onOtpDialogChange={handleOtpDialogChange}
          validSSORequestId={validSSORequestId}
          consentForm={consentForm}
        />
        {!isOtpStep && <TermsConditions showSecuredLogo={false} variant="compact" />}
      </div>
      <div className="mt-auto flex w-full items-center justify-center pb-3 pt-4">
        <ShopfloBadge />
      </div>
    </div>
  );
};

export default Login;
